import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  DisciplineConfigForTrainerDocument,
  DisciplineConfigForTrainerQuery,
  DisciplineConfigForTrainerQueryVariables
} from '../../../graphql-operations';
import DisciplineConfigForTrainerView from './DisciplineConfigForTrainerView';

interface DisciplineConfigForTrainerDetailProps {
  disciplineConfigId?: string;
  listUrl: string;
}

export default function DisciplineConfigForTrainerDetail({ disciplineConfigId, listUrl }: DisciplineConfigForTrainerDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl} />

      {!!disciplineConfigId && (
        <QueryWithLoader<DisciplineConfigForTrainerQuery, DisciplineConfigForTrainerQueryVariables>
          query={DisciplineConfigForTrainerDocument}
          variables={{ disciplineConfigId }}
        >
          {({ data }) => {
            const disciplineConfigForTrainer = data.disciplineConfigForTrainer;

            if (!disciplineConfigForTrainer) {
              return <Redirect to="/page-not-found" />;
            }

            return <DisciplineConfigForTrainerView disciplineConfigForTrainer={disciplineConfigForTrainer} />;
          }}
        </QueryWithLoader>
      )}

      {!disciplineConfigId && <NoData text="Vyberte oddíl" />}
    </>
  );
}
